/**
 * Represents the types of events published by XbcbMessageExchangeAuthority
 */
export enum ExchangeMessageEvent {
  XBCB_EXCHANGE_MESSAGE_CREATED_EVENT = 'XBCB_EXCHANGE_MESSAGE_CREATED_EVENT',
  XBCB_EXCHANGE_MESSAGE_UPDATED_EVENT = 'XBCB_EXCHANGE_MESSAGE_UPDATED_EVENT',
  XBCB_EXCHANGE_MESSAGE_EXPIRED_EVENT = 'XBCB_EXCHANGE_MESSAGE_EXPIRED_EVENT',
}
